module.exports = __webpack_public_path__ + "img/office4_7-8-2021.98a722d3.jpg";